import { render } from "./HeaderMainLogo.vue?vue&type=template&id=bc997b10"
import script from "./HeaderMainLogo.vue?vue&type=script&lang=js"
export * from "./HeaderMainLogo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__